// Base layout for common Leano pages.
import { Outlet } from "react-router-dom";
import Toasts from "./commons/Toasts/Toasts";
import Modal from "./commons/Modal/Modal";
import { Fragment } from "react";
import Helper from "./commons/Helper/Helper";
export default function Root() {
  return (
    <Fragment>
      <Toasts />
      <Modal />
      <Helper />
      <Outlet />
    </Fragment>
  );
}
